import { ServerConfig } from "@/config/config";
import { AdminApiKey } from "@/models/admin-api-key";
import { Axios } from "./auth-service";

export class AdminApiKeyServiceClass {
	private readonly url:string = `${ServerConfig.host}/admin/api-keys`;

	async getApiKeys():Promise<AdminApiKey[]>{
		let result = await Axios.get(`${this.url}`);
		return result.data.map((d:any)=>new AdminApiKey(d));
	}

	async createApiKey(name:string):Promise<{apiKey:AdminApiKey, key:string}>{
		let result = await Axios.post(`${this.url}`, {name});
		return {
			apiKey: new AdminApiKey(result.data.apiKey),
			key: result.data.key
		};
	}

	async deleteApiKey(id:number):Promise<void>{
		await Axios.delete(`${this.url}/${id}`);
	}
}

export const AdminApiKeyService = new AdminApiKeyServiceClass();